module.exports = __webpack_public_path__ + "img/area_6.6612d2de.png";